import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [logoUrl, setLogoUrl] = useState("/assets/Images/newLogo.png"); // fallback logo

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Fetch header logo from Firestore (which stores Cloudinary URL)
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const docRef = doc(db, "logos", "xrSCDlcVzp10becG8bnW");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          // Use navbarLogo (Header Logo from SiteSettings)
          if (data.navbarLogo) {
            setLogoUrl(data.navbarLogo); // This is the Cloudinary URL
          } else if (data.headerLogo) {
            setLogoUrl(data.headerLogo); // Alternative field name
          } else if (data["navbar logo"]) {
            setLogoUrl(data["navbar logo"]); // Old format
          }
        } else {
          console.log("No logo document found!");
        }
      } catch (err) {
        console.error("Error fetching logo:", err);
      }
    };

    fetchLogo();
  }, []);

  const toggleMenu = () => {
    const newState = !isMenuOpen;
    setIsMenuOpen(newState);

    const optionElement = document.getElementById("option");
    const actionElement = document.getElementById("action");
    const navbarElement = document.getElementById("top-nav");

    if (optionElement && actionElement && navbarElement) {
      if (newState) {
        optionElement.classList.add("active");
        actionElement.classList.add("active");
        navbarElement.classList.add("menu-open");
      } else {
        optionElement.classList.remove("active");
        actionElement.classList.remove("active");
        navbarElement.classList.remove("menu-open");
      }
    }
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    const optionElement = document.getElementById("option");
    const actionElement = document.getElementById("action");
    const navbarElement = document.getElementById("top-nav");

    if (optionElement && actionElement && navbarElement) {
      optionElement.classList.remove("active");
      actionElement.classList.remove("active");
      navbarElement.classList.remove("menu-open");
    }
  };

  return (
    <div className={`navbar nav_wrapper ${isScrolled ? "scrolled" : ""}`} id="top-nav">
      <div className="page-wrapper ">
        <div className="main">
          {/* ✅ Logo - Cloudinary URL from Firestore */}
          <div id="logo">
            <Link to="/" onClick={closeMenu}>
              <img
                src={logoUrl}
                alt="VisionBird Logo"
                width="140%"
              />
            </Link>
          </div>

          {/* ✅ Hamburger Icons */}
          <div className="show-hide-div">
            <img
              id="top-hide"
              onClick={toggleMenu}
              src="/assets/Images/Group 82.png"
              width="35px"
              alt="Hide menu"
              style={{ display: isMenuOpen ? "block" : "none" }}
            />
            <img
              id="top-show"
              onClick={toggleMenu}
              src="/assets/Images/hanburger.png"
              width="40px"
              height="35px"
              alt="Show menu"
              style={{ display: isMenuOpen ? "none" : "block" }}
            />
          </div>

          {/* ✅ Menu Options */}
          <div id="option">
            <ul>
              <li><Link id="navbutton" to="/" onClick={closeMenu}>HOME</Link></li>
              <li><Link id="navbutton" to="/About" onClick={closeMenu}>ABOUT</Link></li>
              <li><Link id="navbutton" to="/Services" onClick={closeMenu}>SERVICES</Link></li>
              <li><Link id="navbutton" to="/CertifcatePage" onClick={closeMenu}>REGISTRATIONS</Link></li>
              <li><Link id="navbutton" to="/Career" onClick={closeMenu}>CAREER</Link></li>
              {/* <li><Link id="navbutton" to="/Portfolio" onClick={closeMenu}>PORTFOLIO</Link></li> */}

              {/* <li><Link id="navbutton" to="/MainContributors" onClick={closeMenu}>Contributors</Link></li> */}
              <li><Link id="navbutton" to="/ApplyForJob" onClick={closeMenu}>JOIN OUR TEAM</Link></li>
              <li><Link id="navbutton" to="/Future-Reservation" onClick={closeMenu}>SLOT RESERVATION</Link></li>

              <li><Link id="navbutton" to="/Contact" onClick={closeMenu}>CONTACT</Link></li>
            </ul>
          </div>

          {/* ✅ Desktop CTA Button */}
          <div id="action" className="desktop-cta">
            <Link to="/Contact" className="cta-btn-link">
              <button className="cta-btn">
                <span className="talk">LET'S TALK</span>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;